import { WSButton, WSElement, WSText } from "@wingspanhq/fe-component-library";
import { IPayableSchema } from "@wingspanhq/payments/dist/interfaces";
import { useHistory } from "react-router-dom";
import { getPathWorkLogPayerDetails } from "../../modules/WorkLogs/paths";
import { useFeatureFlags } from "../../query/hooks/useFeatureFlags";
import { useQueryWorkItem } from "../../query/workItem/queries/useQueryWorkItem";
import { useQueryWorkLog } from "../../query/workLog/queries/useQueryWorkLog";

type Props = {
  payable: IPayableSchema;
};

export const PayableWorkLog: React.FC<Props> = ({ payable }) => {
  const history = useHistory();
  const queryFeatureFlags = useFeatureFlags();

  const workItemId = payable?.lineItems[0]?.labels?.workItemId as
    | string
    | undefined;

  const queryWorkItem = useQueryWorkItem(workItemId!, {
    enabled: !!workItemId && queryFeatureFlags.data?.workLogReviewWorkflow
  });

  const workLogId = queryWorkItem.data?.workLogId;

  const queryWorkLog = useQueryWorkLog(workLogId!, {
    enabled: !!workLogId && queryFeatureFlags.data?.workLogReviewWorkflow
  });

  if (
    !queryFeatureFlags.data?.workLogReviewWorkflow ||
    !workLogId ||
    !queryWorkLog.data?.workLogNumber
  ) {
    return null;
  }

  return (
    <WSElement>
      <WSText.ParagraphSm color="gray500">
        Created from work log{" "}
        <WSButton.Link
          onClick={() => history.push(getPathWorkLogPayerDetails(workLogId))}
        >
          #{queryWorkLog.data.workLogNumber}
        </WSButton.Link>
      </WSText.ParagraphSm>
      <WSButton.Link
        mt="M"
        onClick={() => history.push(getPathWorkLogPayerDetails(workLogId))}
        rightIcon="chevron-right"
      >
        View work log
      </WSButton.Link>
    </WSElement>
  );
};
